import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {DMenuService} from "../../../services/menu.service";
import {ApiService} from "../../../services/api.service";
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'site-header',
  templateUrl: './site-header.component.html'
})
export class SiteHeaderComponent implements OnInit {
  public menuItems: Object[] = [];
  public menuItemsLoggedIn: Object[] = [];
  public isLoggedIn = ApiService.isLoggedIn;
  public getKeys = Object.keys;
  public currentUrl: boolean = true;

  constructor(private menuService: DMenuService, private userService: UserService, private router: Router) { }

  ngOnInit()
  {
      if(window.location.pathname == "/") {
          this.currentUrl = false;
      }
      this.menuService.get('main').subscribe((res) => {
          this.menuItems = res;
      });
      this.menuService.get('main-logged-in').subscribe((res) => {
          this.menuItemsLoggedIn = res;
      });
  }

  public logout() {
      this.userService.logout().subscribe((res) => {
          //logged out
          this.router.navigate(['/'])
      },(err) => {
          this.router.navigate(['/'])
      });
  }
}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/_blocks/site-header/site-header.component.ts